"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon3x = void 0;
var React = __importStar(require("react"));
var Icon3x = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { id: "Paiement/ic_3x", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
        React.createElement("rect", { id: "Padding", x: "0", y: "0", width: "24", height: "24" }),
        React.createElement("rect", { id: "Rectangle", fill: "#464650", x: "3", y: "3", width: "18", height: "18", rx: "1" }),
        React.createElement("path", { d: "M8.13,17.14 C10.034,17.14 11.658,16.09 11.658,14.13 C11.658,12.856 10.888,12.03 9.824,11.736 C10.524,11.47 11.14,10.728 11.14,9.678 C11.14,8.026 9.74,7.102 8.158,7.102 C6.45,7.102 5.078,8.166 5.078,9.916 L6.38,10.014 C6.394,8.964 7.122,8.376 8.158,8.376 C9.068,8.376 9.796,8.852 9.796,9.846 C9.796,10.826 9.054,11.344 7.682,11.344 L7.682,12.422 C8.83,12.422 10.314,12.548 10.314,14.046 C10.314,15.264 9.348,15.866 8.158,15.866 C6.87,15.866 5.918,15.166 5.918,13.92 L4.602,14.004 C4.602,16.062 6.198,17.14 8.13,17.14 Z M14.304,17 L15.998,14.438 L17.692,17 L19.33,17 L16.866,13.542 L19.316,10.098 L17.692,10.098 L15.998,12.618 L14.29,10.098 L12.666,10.098 L15.102,13.542 L12.666,17 L14.304,17 Z", id: "3x", fill: "#FFFFFF" })))); };
exports.Icon3x = Icon3x;
exports.Icon3x.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.Icon3x;
